import { generateRouteByType } from '@/plugins/utils';
import { acceptOrRejectItemChecklist } from '../../checkList';
import { acceptOrRejectItem, marksAsReadNotification } from '../services';

export default {
  methods: {
    async readNotification({ item = {}, date = '' }) {
      try {
        const type = item.action_object.model;
        const route = generateRouteByType(item, type, this.isParent);
        await marksAsReadNotification({ notificationId: item.id, date });
        this.notificationStore.decrementTotalNotification();
        route && this.$router.push(route);
      } catch (error) {
        console.log(error);
      }
    },
    async handleAcceptingItem(item, type, isAccept) {
      try {
        if (type === 'checklist items') {
          await acceptOrRejectItemChecklist({
            id: item.action_object.id,
            childId: item.child_id,
            isAccept,
          });
        } else {
          await acceptOrRejectItem({ id: item.coins.id, isAccept });
        }
        this.notificationStore.decrementTotalNotification();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
